let userData = null;

export const setUserData = (data) => {
  userData = data;
};

export const getUserData = () => userData;

export const clearUserData = () => {
  userData = null;
};